import React, { useMemo, useState } from "react";
import { Button, Stack, TableCell, TableRow } from "@mui/material";
import LegalbirdIoModal from "../../../Modal/LegalbirdIoModal";
import BeaSearch from "../../../BeaSearch/BeaSearch";
import { BeaSearchResult } from "../../../../types/Bea/BeaSearchResult";
import _ from "lodash";
import { ProductUnion } from "../../../../types/ProductUnion";

type BeaLawyerImportButtonProps = {
  product: ProductUnion;
  handleChange: Function;
  values: {
    [key: string]: string;
  };
};

export default function BeaLawyerImportButton({ product, handleChange, values }: BeaLawyerImportButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const onImportAllDataClick = (
    { surname, streetnumber, city, safeId, street, postalcode, firstname }: BeaSearchResult,
    gender: string
  ) => {
    handleChange({ target: { name: `${product.productClassName}.opponentLawyer.gender`, value: gender } });
    handleChange({ target: { name: `${product.productClassName}.opponentLawyer.familyName`, value: surname || "" } });
    handleChange({ target: { name: `${product.productClassName}.opponentLawyer.givenName`, value: firstname || "" } });
    handleChange({
      target: {
        name: `${product.productClassName}.opponentLawFirm.organization.address.streetAddress`,
        value: street + " " + streetnumber || "",
      },
    });
    handleChange({
      target: {
        name: `${product.productClassName}.opponentLawFirm.organization.address.postalCode`,
        value: postalcode || "",
      },
    });
    handleChange({
      target: {
        name: `${product.productClassName}.opponentLawFirm.organization.address.addressLocality`,
        value: city || "",
      },
    });
    handleChange({
      target: { name: `${product.productClassName}.opponentLawFirm.organization.beaSafeId`, value: safeId || "" },
    });
    setModalOpen(false);
  };

  const onImportSafeIdClick = (beaSafeId: string) => {
    handleChange({
      target: { name: `${product.productClassName}.opponentLawFirm.organization.beaSafeId`, value: beaSafeId || "" },
    });
    setModalOpen(false);
  };

  const SearchResultExtension = ({ searchResult, gender }: { searchResult: BeaSearchResult; gender: string }) => {
    return (
      <TableRow>
        <TableCell colSpan={7}>
          <Stack direction={"row"} spacing={2} sx={{
            justifyContent: "flex-end"
          }}>
            <Button fullWidth={false} onClick={() => onImportSafeIdClick(searchResult.safeId)}>
              Bea-Adresse Übernehmen
            </Button>
            <Button
              variant={"contained"}
              fullWidth={false}
              onClick={() => onImportAllDataClick(searchResult, gender)}
              disabled={!gender}
            >
              Alle Daten Übernehmen
            </Button>
          </Stack>
        </TableCell>
      </TableRow>
    );
  };

  const initialValues = useMemo(() => {
    return {
      surname: _.get(values, `${product.productClassName}.opponentLawyer.familyName`, ""),
      firstname: _.get(values, `${product.productClassName}.opponentLawyer.givenName`, ""),
      postalCode: _.get(values, `${product.productClassName}.opponentLawFirm.organization.address.postalCode`, ""),
      city: _.get(values, `${product.productClassName}.opponentLawFirm.organization.address.addressLocality`, ""),
    };
  }, [modalOpen]);

  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "flex-end",
        height: "100%"
      }}>
      <Button onClick={() => setModalOpen(true)} fullWidth={false}>
        Daten aus Bea einfügen
      </Button>
      <LegalbirdIoModal
        handleClose={() => setModalOpen(false)}
        open={modalOpen}
        submitButton={<></>}
        hasActions={false}
        title={"Daten aus beA einfügen"}
        maxWidth={"lg"}
      >
        <BeaSearch
          ResultRowExtension={SearchResultExtension}
          initialValues={initialValues}
          searchResultTypeFilter={"RECHTSANWALT"}
        />
      </LegalbirdIoModal>
    </Stack>
  );
}
